module.exports = __webpack_public_path__ + "img/canvas.14630229.svg";